import React, { ReactNode } from 'react';
import { Container, Stack, Typography } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { theme } from '../../constants/theme';
import { Spinner } from '@chakra-ui/react';
import MoreIcon from '../CustomSVGIcons/MoreIcon';

interface EventManagerWrapperProps {
    children: ReactNode;
    loading?: boolean;
    header?: string;
    withEndIcon?: boolean;
    onIconClick?: () => void;
}

export const EventManagerWrapper: React.FC<EventManagerWrapperProps> = ({
    children,
    loading,
    header,
    withEndIcon,
    onIconClick,
}) => {
    const { themeStyle } = useThemeContext();

    return (
        <Container
            disableGutters
            maxWidth={false}
            sx={{
                py: 4,
                pr: { xs: 2, sm: 3, md: 4, xl: 3 },
                pl: { xs: 2, sm: 11, md: 12, xl: '130px' },
                width: '100%',
            }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" my={2}>
                <Typography
                    sx={{
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                        fontSize: '2rem',
                        color: theme[themeStyle].primary_white,
                        mb: 1,
                    }}>
                    {header ?? 'Manage Event'}
                </Typography>

                {loading && <Spinner h={3} w={3} color={theme[themeStyle].tag_white} mx={2} />}
                {withEndIcon && (
                    <MoreIcon
                        stroke={theme[themeStyle].tag_white}
                        onClick={onIconClick}
                        style={{ cursor: 'pointer' }}
                    />
                )}
            </Stack>

            {children}
        </Container>
    );
};
